var React = require("react");
const createReactClass = require('create-react-class');

var InputMixin = require("./FormInputMixin.jsx");

module.exports = createReactClass({
	mixins: [InputMixin],

	componentWillReceiveProps: function(nextProps) {
		if (this.state.value !== nextProps.value) {
			this.setState({
				value: nextProps.value,
				isValid: true,
			})
		}
	},

	render: function () {
		return (
			<div>
				<input
					id={this.props.name}
					type="hidden"
					className={this.props.className}
					name={this.props.name}
					onChange={this.setValue}
					value={this.state.value}
				/>
			</div>
		);
	}
});
